import React from "react";
import { Grid } from "@mui/material";
import i18next from "i18next";
import RuleSelectInput from "components/rules/RuleSelectInput";
import ScopeCriterionValues from "./ScopeCriterionValues";

const ScopeCriterionFormFieldsReadOnly = ({
  index,
  criterionFieldOptions,
  initialOperatorOptions = [],
  initialValueOptions = [],
  fieldName,
  criterion
}) => {
  return (
    <Grid container spacing={2} style={{ alignItems: "center" }}>
      <Grid item xs={12} md={5}>
        <RuleSelectInput
          fieldName={`${fieldName}.${index}.field`}
          label={
            index === 0 &&
            `${i18next.t("rules.configuration.criteria.fields.field.label")}`
          }
          placeholder={i18next.t(
            `rules.configuration.criteria.fields.field.placeholder`
          )}
          options={criterionFieldOptions}
          onChange={(newValue) => {}}
          validate={() => { return null; }}
          labelVariant="chip"
          disabled
          value={criterion.field}
        />
      </Grid>

      <Grid item xs={12} md={2}>
        <RuleSelectInput
          fieldName={`${fieldName}.${index}.operator`}
          label={
            index === 0 &&
            `${i18next.t("rules.configuration.criteria.fields.operator.label")}`
          }
          placeholder={i18next.t(
            `rules.configuration.criteria.fields.operator.placeholder`
          )}
          options={initialOperatorOptions}
          onChange={() => {}}
          validate={() => { return null; }}
          labelVariant="chip"
          disabled
          value={criterion.operator}
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <ScopeCriterionValues
          index={index}
          criterionFieldOptions={criterionFieldOptions}
          availableValueOptions={initialValueOptions}
          fieldName={fieldName}
          readOnly
          criterion={criterion}
        />
      </Grid>
    </Grid>
  );
};

export default ScopeCriterionFormFieldsReadOnly;
